export class Direction {
    Code: string;
    Name: string;
  }